export default {
	InvalidPaymentData: 1,
	InvalidPaymentProcessor: 2,
	UnknownPaymentProcessor: 3,
	InvalidAmount: 4
};
